import type {SubAgent} from '../types/agent'
import {fetchCAPI} from '../utils/fetch-capi'
import {useCAPIQuery} from './useCAPIQuery'
import type {DropdownRepository} from './useCopilotRepoFetching'

export function useSubAgents({repo}: {repo: DropdownRepository}) {
  const query = useCAPIQuery<SubAgent[]>({
    queryKey: ['custom-agents', repo.owner, repo.nameOnly],
    queryFn: async () => {
      try {
        const response = await fetchCAPI({
          path: `/agents/swe/custom-agents/${repo.owner}/${repo.nameOnly}`,
          retryOn401: true,
        })

        if (response.status === 404) {
          return []
        }

        const data = await response.json()
        const agents = data.agents as SubAgent[]

        return agents
      } catch {
        return []
      }
    },
  })

  return query
}
